<header class="admin-topbar">



  <!-- Hamburger (mobile / collapse toggle) -->

  <button class="menu-toggle" (click)="menuToggle.emit()" aria-label="Toggle sidebar">

    <span class="pi pi-bars"></span>

  </button>





  <!-- Right: Actions -->

  <div style="display:flex; align-items:center; gap:8px;">



    <!-- Live clock -->

    <div class="topbar-clock">
      <span class="pi pi-clock"></span>
      <span class="topbar-clock-time">{{ currentTime }}</span>
    </div>



    <!-- Color theme -->

    <app-theme-picker></app-theme-picker>



    @if (setupAttentionService.showSetupButton()) {

      <button

        class="setup-guide-btn"

        data-tour="topbar-setup"

        (click)="openSetupGuide($event)"

        aria-label="Open setup guide">

        <span class="pi pi-flag"></span>

        <span class="setup-guide-label">Setup</span>

        <span class="setup-guide-badge">{{ setupAttentionService.pendingCount() }}</span>

      </button>

    }



    @if (showGuidesButton) {

      <button

        class="setup-guide-btn guides-btn"

        (click)="openGuidesModal($event)"

        aria-label="Open setup guides and tutorials">

        <span class="pi pi-book"></span>

        <span class="setup-guide-label">Guides</span>

      </button>

    }



    <!-- Wiki / Help -->

    <button class="icon-btn topbar-wiki-btn" data-tour="topbar-wiki" (click)="toggleWiki(); $event.stopPropagation()"

      aria-label="Help & Documentation"

      [style.background]="wikiPanelService.isOpen() ? '#EEF2FF' : ''"

      [style.borderColor]="wikiPanelService.isOpen() ? '#C7D2FE' : ''">

      <span class="pi pi-question-circle" style="font-size:15px;"

        [style.color]="wikiPanelService.isOpen() ? 'var(--tp-primary)' : '#94A3B8'"></span>

    </button>



    <!-- Notifications -->

    <div class="notif-wrapper" data-tour="topbar-notifications" (click)="$event.stopPropagation()">

      <button class="icon-btn" (click)="toggleNotifications($event)" aria-label="Notifications">

        <span class="pi pi-bell" style="font-size:15px; color:var(--tp-text-faint);"></span>

        <span *ngIf="(notificationHubService.notifications$ | async)?.filter(n => !n.isRead)?.length as unread" class="notif-badge">

          {{ unread > 9 ? '9+' : unread }}

        </span>

      </button>

      <app-notification-panel *ngIf="showNotifications"></app-notification-panel>

    </div>



    <!-- Divider -->

    <div class="topbar-divider"></div>



    @if (showTourButton) {

      <button

        class="icon-btn topbar-tour-btn"

        data-tour="topbar-tour"

        (click)="startEmployeeTour($event)"

        aria-label="Take employee portal tour"

        title="Take a tour">

        <span class="pi pi-compass" style="font-size:15px; color:var(--tp-text-faint);"></span>

      </button>

    }



    <!-- User -->

    <a class="user-chip" data-tour="topbar-profile" routerLink="/me/profile" title="My Profile">

      <div style="width:32px; height:32px; border-radius:50%; background:var(--tp-primary); display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; color:white; flex-shrink:0;">

        {{ userProfileStore.initials() }}

      </div>

      <div class="user-chip-text">

        <p class="user-chip-name">{{ userProfileStore.fullName() }}</p>
        <p class="user-chip-role">{{ userProfileStore.roleName() }}</p>

      </div>

    </a>



    <!-- Logout -->

    <button

      (click)="onLogout()"

      class="icon-btn logout-btn"

      title="Sign out">

      <span class="pi pi-sign-out" style="font-size:15px;"></span>

    </button>



  </div>

</header>



<app-wiki-panel *ngIf="wikiPanelService.isOpen()" (closePanel)="wikiPanelService.close()"></app-wiki-panel>


